import React from 'react';
import {
  AboutExchangeRateModalButton,
  AssetOrganizedPortfolioForeignProps,
  AssetOrganizedPortfolioItemForeignProps,
  isSimple,
} from './PortfolioStuffingAsset';
import { ToggleButton } from '../../PortfolioRatioStuffing/PortfolioRatioStuffingList';
import { useModal } from 'hooks/useModal';
import { useCurrencyMode } from 'hooks/useCurrencyMode';
import { AssetOrganizedPortfolioItem } from './AssetOrganizedPortfolioItem';
import { AssetOrganizedPortfolioContainer } from './AssetOrganizedPortfolioContainer';
import CooperationStoppedModal from 'components/features/modal/CooperationStoppedModal';
import { DisplayableAssetTypeModal } from 'components/features/modal/DisplayableAssetTypeModal';

export const StopAggregate = ({
  refresh,
}: {
  refresh: { isOutOfDate: boolean; account: string };
}) => {
  const [isShowModal, { showModal, hideModal }] = useModal();
  return (
    <>
      {refresh && refresh.isOutOfDate && (
        <div
          className="flex flex-col mb-3 cursor-pointer"
          onClick={e => {
            e.stopPropagation();
            showModal();
          }}>
          <div className="form-error-note">
            <div className="icon-alert"></div>
            <div className="info-label">更新に失敗しました</div>
          </div>
        </div>
      )}
      {isShowModal && (
        <CooperationStoppedModal
          {...{
            isShowModal,
            hideModal,
            account: refresh.account,
          }}
        />
      )}
    </>
  );
};

export const DisplayableAssetTypeModalButton = ({
  isMoneytree,
}: {
  isMoneytree: boolean;
}): React.ReactElement => {
  const [isShowModal, { showModal, hideModal }] = useModal();
  return (
    <>
      <button
        className="text-bluegray-500 text-sm flex flex-row items-center"
        onClick={showModal}>
        表示できる資産種別
        <div className="icon-info text-bluegray-400 text-base ml-2 mb-0.5"></div>
      </button>
      <DisplayableAssetTypeModal
        {...{ isShowModal, hide: hideModal, isMoneytree }}
      />
    </>
  );
};

const AssetOrganizedPortfolioItemForeign = ({
  currencyMode,
  amount,
  unit,
  profitOrLoss,
  profitOrLossColor,
  ...rest
}: AssetOrganizedPortfolioItemForeignProps) => {
  switch (currencyMode) {
    case 'FOREIGN':
      return (
        <AssetOrganizedPortfolioItem
          {...{
            ...rest,
            amount: amount.FOREIGN,
            unit,
            profitOrLoss: isSimple(profitOrLoss)
              ? profitOrLoss
              : profitOrLoss.FOREIGN,
            profitOrLossColor: isSimple(profitOrLossColor)
              ? profitOrLossColor
              : profitOrLossColor.FOREIGN,
          }}
        />
      );
    case 'JPY':
      return (
        <AssetOrganizedPortfolioItem
          {...{
            ...rest,
            amount: amount.JPY,
            profitOrLoss: isSimple(profitOrLoss)
              ? profitOrLoss
              : profitOrLoss.JPY,
            profitOrLossColor: isSimple(profitOrLossColor)
              ? profitOrLossColor
              : profitOrLossColor.JPY,
          }}
        />
      );
  }
};

export const AssetOrganizedPortfolioForeign = ({
  assetTypeKey,
  items,
}: AssetOrganizedPortfolioForeignProps) => {
  const { currencyMode, toggle } = useCurrencyMode();
  return (
    <>
      <AssetOrganizedPortfolioContainer
        {...{
          assetTypeKey,
          SubInformation: () => {
            return (
              <>
                <div className="flex flex-grow items-center">
                  <ToggleButton {...{ currencyMode, toggle }} />
                  <AboutExchangeRateModalButton
                    isShowMessage
                    className="ml-auto"
                  />
                </div>
              </>
            );
          },
        }}>
        {items.map((item, index) => (
          <AssetOrganizedPortfolioItemForeign
            {...{ ...item, key: index, assetTypeKey, currencyMode }}
          />
        ))}
      </AssetOrganizedPortfolioContainer>
    </>
  );
};
